/**
 * What the client sees once the conversation is over.
 *
 * The end of the client's involvement, and deliberately the end of what they
 * are shown: no report, no record of what was said, no summary of what was
 * captured, and no internal state. Everything after this point happens on the
 * backend, without them.
 */

import { useState } from 'react';
import '../styles/BusinessAssessment.css';

function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" className="bd-icon" aria-hidden="true" focusable="false">
      <path d="M5 12.5l4.5 4.5L19 7.5" />
    </svg>
  );
}

export default function CompletionPage() {
  const [showCloseHint, setShowCloseHint] = useState(false);

  // A browser only lets a page close a window that a script opened. When it
  // refuses, say so rather than leave the button looking broken.
  const close = () => {
    window.close();
    setShowCloseHint(true);
  };

  return (
    <section className="bd-panel bd-complete" aria-labelledby="bd-complete-title">
      <div className="bd-complete__tick" aria-hidden="true">
        <CheckIcon />
      </div>
      <h1 id="bd-complete-title" className="bd-title">Thank You!</h1>
      <p className="bd-lede">Your business discovery conversation has been completed.</p>
      <p className="bd-body">Our team will review the information and follow up if needed.</p>
      <button type="button" className="bd-button bd-button--primary" onClick={close}>
        Close
      </button>
      {showCloseHint && (
        <p className="bd-meta" role="status">You can now close this browser tab.</p>
      )}
    </section>
  );
}
